import { useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CtaWpp = () => {
  const [text, setText] = useState("Fale conosco agora mesmo!");

  return (
    <button id="ctaWpp">
      <a
        href="http://wa.me/+5511973350633?text=Olá,%20Gostaria%20de%20falar%20com%20o%20advogado"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaWpp;
